export default "__VITE_ASSET__BYljh7pX__"